import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { CanActivateFn } from '@angular/router';
import { AuthenticationService } from '../service/authentication.service';
import { roles } from '../constant/roles';
import { TranslateService } from '@ngx-translate/core';
import {lightGuard} from "./light.guard";
import {isLightRoute} from "@adlatus-gui/shared";

export const normalRoles = [
  roles.CLEARING_ADMINISTRATOR,
  roles.CLEARING_OPERATOR,
  roles.CLEARING_VIEWER
];

export const normalGuard: CanActivateFn = async (route, state) => {
  const authenticationService = inject(AuthenticationService);
  const messageService = inject(MessageService);
  const translateService = inject(TranslateService);
  if (isLightRoute()) return false;

  const isNormalUser = authenticationService
    .getUserRoles()
    .some(role => normalRoles.includes(role));

  if (!isNormalUser)
    messageService.add({
      severity: 'error',
      sticky: true,
      summary: translateService.instant('forbidden.summary'),
      detail: translateService.instant('forbidden.detail')
    });

  return isNormalUser;
};
